'use client'

interface GTMBodyScriptProps {
    gtmKey: string
}

export const GTMBodyScript = ({ gtmKey }: GTMBodyScriptProps) => (
    <noscript>
        <iframe
            title="gtm"
            src={`https://www.googletagmanager.com/ns.html?id=${gtmKey}`}
            height="0"
            width="0"
            style={{ display: 'none', visibility: 'hidden' }}
        />
    </noscript>
)
